import { RootState } from '../store';

export const selectSalaryPeriodOptions = (state: RootState) => state.salaryPeriod.salaryPeriodOptions;

export const selectSalaryPeriodOptionsRequestStatus = (state: RootState) =>
  state.salaryPeriod.salaryPeriodOptionsRequestStatus;
